jQuery(document).ready(function ($) {
	$('.sub-nav .menu-item-has-children').click(function () {
		var $this = this;
		$($this).toggleClass('active');
		$($this).find('.dropdown-menu').toggleClass('show');
	});

	$('input[name="EMAIL"]').keypress(function (event) {
		var keycode = (event.keyCode ? event.keyCode : event.which);
		if (keycode === '13') {
			event.preventDefault();
			jQuery('#newsletter_modal').modal('show')
		}
		event.stopPropagation();
	});

	$('div#contact_bidwriter').on('show.bs.modal', function (e) {
		var target = e.relatedTarget.dataset['id'];
		$('input[name="dynamicname"]').val(target);
	});

	document.addEventListener('wpcf7mailsent', function (event) {
		$('.wpcf7-response-output').addClass('alert alert-success');
	}, false);

	var disableSubmit = false;
	$('input.wpcf7-submit[type="submit"]').click(function () {
		$(':input[type="submit"]').attr('value', "Sending...");
		if (disableSubmit === true) {
			return false;
		}
		disableSubmit = true;
		return true;
	});

	var wpcf7Elm = document.querySelector('.wpcf7');
	wpcf7Elm.addEventListener('wpcf7submit', function (event) {
		$(':input[type="submit"]').attr('value', "Send");
		disableSubmit = false;
	}, false);
});
